export const bankKeys = {
  base: ["bank"],
  denom: (params: Record<string, number | string | undefined>) => [
    ...bankKeys.base,
    "denom",
    params,
  ],
};
